import {Row} from "antd";
import styled from "styled-components";

export const WalletSummaryContainer = styled(Row)`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
`;
